import React, { useState, useContext, useEffect } from 'react';
import { UserContext } from '../../contexts/userContext';
import request from '../../../services/Request';
import ModernTable, { ModernPageContainer, ModernPageHeader } from '../components/ModernTable';
import LoadingIcon from '../../items/buttons/LoadingIcon';
import { Grid, Container, Box, Typography, Chip, alpha } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import MachineSelect from '../../dashboard/report/MachineSelect';
import { userLimits } from '../../dashboard/uitls/userLimits';
import moment from 'moment';
import { localDateRange } from '../../../services/method/methods';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ComputerIcon from '@mui/icons-material/Computer';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import CreditCardIcon from '@mui/icons-material/CreditCard';

const getOrderByEmail = `/credit/cashTrans`;
const getAllOrder = `/allOrders/`;
const getGroupsURL = `/groupsAndMachines/`;

Date.prototype.toShortFormat = function () {
  let monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  let day = this.getDate();

  let monthIndex = this.getMonth();
  let monthName = monthNames[monthIndex];

  let year = this.getFullYear();

  return `${day}-${monthName}-${year}`;
};

export default function CashTrans(props) {
  const theme = useTheme();
  const { userEmail, filterd, setFiltered } = useContext(UserContext);

  //start at first date of this month
  var date = new Date();
  const [startDate, setStartDate] = useState(new Date(date.getFullYear(), date.getMonth(), 1));
  const [endDate, setEndDate] = useState(new Date());
  const [order, setOrder] = useState([]);
  const [machines, setMachines] = useState([]);
  const [machineName, setMachineName] = useState('All Machines');
  const [loading, setLoading] = useState(false);
  const [groups, setGroups] = useState([]);
  const [groupV, setgroupV] = useState([]);
  const [radio, setRadio] = useState('a');
  const user = JSON.parse(localStorage.getItem('user'));
  const thirdParty = user.thirdPartyLink;

  const [pagination, setPagination] = useState(
    localStorage.getItem('table_view_cash') ? localStorage.getItem('table_view_cash') : 20
  );

  useEffect(() => {
    localStorage.setItem('table_view_cash', pagination);
  }, [pagination]);

  // console.log(user);

  const { id, tableTitle, superAdmin } = userLimits(
    props.match.params.id,
    props.match.params.group,
    'Transactions',
    'view_trans'
  );

  useEffect(() => {
    let allMachines = [];
    let isCancelled = false;

    async function getGroups() {
      await request({
        method: 'get',
        url: !props.match.params.group && superAdmin ? getGroupsURL : getGroupsURL + userEmail,
      }).then((res) => {
        if (!isCancelled) {
          setGroups(res.data.groups);
          setMachines(res.data.machines);
          setLoading(true);
          allMachines = res.data.machines.map((e) => e._id);
        }
      });
    }

    getGroups();

    return () => {
      isCancelled = true;
    };
  }, []);

  const handleStartDate = (e) => {
    setStartDate(e);
  };

  const handleEndDate = (e) => {
    setEndDate(e);
  };

  const handleSearch = async (event) => {
    // console.log('startDateString', new Date(startDateString));
    // console.log('endDateString', new Date(endDateString));
    let filteredArray = [];
    setLoading(false);
    let myIDs = 0;
    if (radio == 'a') {
      setFiltered(machines);
      myIDs = machines.map((e) => e._id).join(',');
      setMachineName('All Machines');
      filteredArray = [...machines];
    }
    if (radio == 'g') {
      const myArray = groupV.map((e) => e.machineID);
      var merged = [].concat.apply([], myArray);
      merged = merged.filter((e, i, self) => i === self.findIndex((t) => t._id == e._id));
      // const filteredArray = machines.filter((e, i) => i == merged.findIndex((t)=>(t._id == e._id)));
      machines.forEach((e) => {
        merged.findIndex((t) => {
          if (t._id == e._id) {
            filteredArray.push(e);
          }
        });
      });
      setFiltered(filteredArray);
      myIDs = filteredArray.map((e) => e._id).join(',');
      setMachineName(`Groups: ${groupV.map((e) => e.name).join(', ')} `);
    }
    if (radio == 'm') {
      setFiltered(groupV);
      filteredArray = [...groupV];
      myIDs = groupV.map((e) => e._id).join(',');
      setMachineName(`Machines: ${groupV.map((e) => e.name).join(', ')} `);
    }
    // console.log(myIDs);
    // console.log(startDateString)
    // console.log(endDateString)
    if (myIDs.length > 0) {
      const { startDateString, endDateString } = localDateRange(startDate, endDate);
      await request({
        method: 'post',
        url:
          !props.match.params.group && superAdmin
            ? getAllOrder + myIDs + '/' + startDateString + '/' + endDateString
            : getOrderByEmail,
        data: {
          start: startDateString,
          end: endDateString,
          ids: myIDs,
          id: id,
        },
      }).then(async (res) => {
        console.log('res.data', res.data);
        setOrder(res.data);
        setLoading(true);
      });
    } else {
      setLoading(true);
    }
  };
  let columns = [
    {
      title: 'ID',
      field: 'cashID',
      render: (rowData) => (
        <Typography variant="body2" sx={{ fontFamily: 'monospace', fontWeight: 600 }}>
          {rowData.cashID}
        </Typography>
      ),
    },
    {
      title: 'Date',
      field: 'local_time',
      render: (rowData) => {
        let date = new Date(rowData.local_time);
        date = moment.utc(date).format('lll');
        return (
          <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '0.875rem' }}>
            {date}
          </Typography>
        );
      },
    },
    {
      title: 'Machine ID',
      field: 'machineID.name',
      render: (rowData) => (
        <Chip
          label={rowData.machineID?.name}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.info.main, 0.12),
            color: theme.palette.info.dark,
            border: `1.5px solid ${alpha(theme.palette.info.main, 0.3)}`,
          }}
        />
      ),
    },
    {
      title: 'Total Amount($)',
      field: 'total_amount',
      render: (rowData) => {
        if (rowData?.total_amount) {
          return (
            <Chip
              icon={<AttachMoneyIcon sx={{ fontSize: 16 }} />}
              label={rowData.total_amount}
              size="small"
              sx={{
                fontWeight: 600,
                backgroundColor: alpha(theme.palette.success.main, 0.12),
                color: theme.palette.success.dark,
                border: `1.5px solid ${alpha(theme.palette.success.main, 0.3)}`,
                '& .MuiChip-icon': {
                  color: theme.palette.success.dark,
                },
              }}
            />
          );
        } else {
          return (
            <Chip
              label="Cash Back"
              size="small"
              sx={{
                fontWeight: 600,
                backgroundColor: alpha(theme.palette.grey[500], 0.12),
                color: theme.palette.text.secondary,
                border: `1.5px solid ${alpha(theme.palette.grey[500], 0.3)}`,
              }}
            />
          );
        }
      },
    },
    {
      title: 'Cash In($)',
      field: 'cashIn',
      render: (rowData) => (
        <Chip
          label={rowData?.cashIn.join(', ')}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.success.main, 0.12),
            color: theme.palette.success.dark,
            border: `1.5px solid ${alpha(theme.palette.success.main, 0.3)}`,
          }}
        />
      ),
    },
    {
      title: 'Cash Out($)',
      field: 'cashOut',
      render: (rowData) => (
        <Chip
          label={rowData?.cashOut.join(', ')}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.warning.main, 0.12),
            color: theme.palette.warning.dark,
            border: `1.5px solid ${alpha(theme.palette.warning.main, 0.3)}`,
          }}
        />
      ),
    },
    {
      title: 'Credit Amount($)',
      field: 'amount',
      render: (rowData) => (
        <Chip
          label={rowData.amount}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.primary.main, 0.12),
            color: theme.palette.primary.dark,
            border: `1.5px solid ${alpha(theme.palette.primary.main, 0.3)}`,
          }}
        />
      ),
    },
    {
      title: 'Credit Note',
      field: 'credit',
      render: (rowData) => (
        <Chip
          label={rowData.credit ? 'True' : 'False'}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: rowData.credit
              ? alpha(theme.palette.error.main, 0.12)
              : alpha(theme.palette.grey[500], 0.12),
            color: rowData.credit ? theme.palette.error.dark : theme.palette.text.secondary,
            border: `1.5px solid ${
              rowData.credit
                ? alpha(theme.palette.error.main, 0.3)
                : alpha(theme.palette.grey[500], 0.3)
            }`,
          }}
        />
      ),
    },
  ];

  return (
    <ModernPageContainer>
      {!loading && <LoadingIcon />}

      <ModernPageHeader
        title={tableTitle || 'Cash Transactions'}
        subtitle="View cash and credit transactions from machines"
        icon={AttachMoneyIcon}
      />

      <Container maxWidth="xl" sx={{ mt: 3, px: 0 }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <MachineSelect
              filterd={filterd}
              handleStartDate={handleStartDate}
              handleEndDate={handleEndDate}
              startDate={startDate}
              endDate={endDate}
              setRadio={setRadio}
              setgroupV={setgroupV}
              radio={radio}
              groupV={groupV}
              groups={groups}
              machines={machines}
              handleChange={handleSearch}
            />
          </Grid>
        </Grid>
      </Container>

      <Box sx={{ mt: 3 }}>
        <ModernTable
          onRowsPerPageChange={setPagination}
          columns={columns}
          data={order}
          options={{
            actionsColumnIndex: -1,
            pageSize: parseInt(pagination),
            pageSizeOptions: [10, 20, 50, 100, 200],
            rowStyle: (rowData) => {
              if (rowData?.credit) {
                return {
                  backgroundColor:
                    theme.palette.mode === 'dark'
                      ? alpha(theme.palette.error.main, 0.1)
                      : alpha('#DEADDD', 0.3),
                };
              }
              if (!rowData.total_amount) {
                return {
                  backgroundColor: alpha(theme.palette.grey[500], 0.1),
                };
              }
            },
          }}
          actions={[]}
        />
      </Box>
    </ModernPageContainer>
  );
}
